/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, July 2020
 */

import { useContext, useEffect, useReducer } from 'react';
import PageContext from './page-context';

export default function usePageStateManager() {
  const { pageStateManager } = useContext(PageContext);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  useEffect(() => {
    pageStateManager.on('update', forceUpdate);
    return () => {
      pageStateManager.off('update', forceUpdate);
    };
  }, [pageStateManager, forceUpdate]);
  return pageStateManager;
}
